import React from 'react';
import classnames from 'classnames';
import { Panel } from 'react-bootstrap';
import LabeledCheckbox from '../LabeledCheckbox.jsx';
import { setProjectFilterFlag } from '../../context/projectFilter.js';
import { useStateValue } from '../../context/state.jsx';

const FilterByFlag = () => {
	const [{ datasets, currentDataset, projectFilter }, dispatch] = useStateValue();

	const datasetInfo = currentDataset && datasets ? datasets[currentDataset] : null;
	if (!datasetInfo) {
		return null;
	}
	const { filterOptions } = datasetInfo;

	const handleFlagChange = e => {
		dispatch(setProjectFilterFlag(e.target.value, e.target.checked));
	};

	const flags = filterOptions.flags.map((flag, index) => {
		const checked = flag.Code in projectFilter.flags;
		return (
			<LabeledCheckbox
				key={index}
				textClass={`flag-${flag.Code}`}
				text={flag.Color}
				value={flag.Code}
				checked={checked}
				onChange={handleFlagChange} />
		);
	});
	return (
		<Panel
			className={classnames({activeFilter: Object.keys(projectFilter.flags).length > 0})}>
			<Panel.Heading>
				<Panel.Title toggle>Flags</Panel.Title>
			</Panel.Heading>
			<Panel.Collapse>
				<Panel.Body>
					<div className="labeledCheckboxGroup">{flags}</div>
				</Panel.Body>
			</Panel.Collapse>
		</Panel>
	);
};

export default FilterByFlag;
